import { Injectable } from '@angular/core';
import { CFHttpClient } from '../shared/cf-http-client';
import { UserSession } from '@mem-shared/user-session';
import {environment} from '../../environments/environment';
/**
 * EmailTextPromoService will provide data via HTTP for all
 * EmailTextPromo component
 */
@Injectable()
export class EmailTextPromoService {
  constructor(private http: CFHttpClient, public userSession: UserSession) {}

/**
 * This service call will bring required details
 *
 */
getMemberCommunicationInfo() {
  const url = environment.serviceSecuredURLs.getMemberCommunicationURL; //'/mas/sec/getMemberCommunicationInfo.json';
  return this.http.get(url);
}


}



// WEBPACK FOOTER //
// ./src/app/email-text-promo/email-text-promo.service.ts